import { ChainMismatchError } from "wagmi";

export function useWriteException(writeError) {
    let writeErrorMessage = 'Error. Try again.';
    if (writeError instanceof ChainMismatchError) {
        writeErrorMessage = 'Your wallet is connected to the wrong chain.'
    }
    return writeErrorMessage;
}